import {
   VisitDocumentTemplateHtmlContent,
   VisitDocumentTemplateRealDataHtmlQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { DocumentTemplateFormBean } from '~libs.desktop.shared.document-template';

import { consentTemplateDraftSchema, getConsentTemplateDraftToken } from './consentTemplate.draft';
import { translationKeys } from './translations';

type ConsentTemplateFormRenderProps = {
   consentTemplate: VisitDocumentTemplateHtmlContent;
   consentTemplateDraft: DocumentTemplateFormBean | null;
};

type ConsentTemplateFormLoaderProps = {
   readonly visitId: number;
   readonly printTemplateId: number;
   readonly children: (renderProps: ConsentTemplateFormRenderProps) => JSX.Element;
};

export const ConsentTemplateFormLoader = (props: ConsentTemplateFormLoaderProps): JSX.Element => {
   const {
      data: consentTemplate,
      loading: consentTemplateLoading,
      error: consentTemplateError,
   } = useCqrsGet<VisitDocumentTemplateHtmlContent>(() => {
      const query = new VisitDocumentTemplateRealDataHtmlQuery();
      query.visitId = props.visitId;
      query.printTemplateId = props.printTemplateId;
      return query;
   });

   const {
      data: consentTemplateDraft,
      loading: consentTemplateDraftLoading,
      error: consentTemplateDraftErorr,
   } = useDraftCqrsFind(
      {
         token: getConsentTemplateDraftToken(props.visitId, props.printTemplateId),
      },
      consentTemplateDraftSchema
   );

   if (consentTemplateLoading || consentTemplateDraftLoading) {
      return <LoaderSpinner />;
   }

   if (consentTemplateError || consentTemplateDraftErorr) {
      return (
         <Message
            testId={'consentTemplateFetchError'}
            type={MessageType.NEGATIVE}
            label={translationKeys.consentTemplateFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      consentTemplate: consentTemplate,
      consentTemplateDraft: consentTemplateDraft?.contents ?? null,
   });
};
